import {useFetchOneEntry} from 'hec/hooks/useFetchOneEntry'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import modelMap from 'hec/builder/model-map'

export const useFetchHeader = ({name, shouldQuery}) => {
    const config = getConfig()

    return useFetchOneEntry({
        queryKey: [`header`, name],
        options: {
            model: modelMap.header,
            apiKey: config.app.builder.api,
            query: {
                name
            }
        },
        enabled: shouldQuery
    })
}
